var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "currrentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(6.66602 6.66699)",
    fill: "currrentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.666,
    cy: 24.667,
    r: 17.5,
    stroke: "#848FA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.267 14.0158C23.8766 14.8039 23.6061 15.2782 22.9946 16.2466C22.7054 16.7046 22.4793 17.0534 21.5617 18.4571C21.0115 19.2987 20.4187 20.2185 20.2633 20.4715C20.1721 20.6201 20.0572 20.8037 20.0081 20.8795C19.959 20.9552 19.8082 21.204 19.6729 21.4322C18.7044 23.0668 18.0565 24.4918 17.6243 25.9374C17.5158 26.3005 17.3774 27.0185 17.3095 27.571C17.2656 27.9277 17.2652 29.1313 17.3089 29.4626C17.4483 30.5212 17.6586 31.2397 18.0604 32.0298C18.5644 33.0209 19.3801 33.9725 20.3095 34.6539C20.7257 34.9588 21.5071 35.3905 21.8986 35.5315C22.9348 35.9049 23.5683 36.0214 24.5505 36.0192C25.1517 36.0179 25.4472 35.99 25.9736 35.8852C27.8607 35.5094 29.5282 34.3888 30.6077 32.7709C31.4458 31.5147 31.8612 30.118 31.8619 28.5537C31.8623 27.6428 31.6831 26.567 31.3679 25.5879C30.816 23.8736 30.1223 22.4855 28.676 20.2013C28.1615 19.3887 27.9975 19.1348 27.0414 17.671C25.7514 15.6958 25.4494 15.1956 24.939 14.1891C24.7458 13.808 24.5752 13.4926 24.5599 13.4883C24.5446 13.484 24.4128 13.7214 24.267 14.0158ZM20.9553 22.7991C20.871 22.9328 20.4788 23.7375 20.2758 24.1932C20.1705 24.4297 20.0693 24.6563 20.0509 24.6968C19.7961 25.2597 19.4712 26.2964 19.385 26.8218C19.2737 27.4995 19.2713 29.1344 19.3808 29.6469C19.4967 30.1889 19.8057 30.9436 20.1253 31.4647C20.75 32.4835 21.6001 33.261 22.6222 33.7485C22.9557 33.9075 23.4434 34.0933 23.5274 34.0933C23.5844 34.0933 23.5397 34.048 23.2047 33.7667C22.6061 33.2639 22.0636 32.5126 21.5871 31.5262C21.3347 31.0037 21.1883 30.6245 20.9327 29.8311C20.8784 29.6628 20.7583 29.1487 20.7116 28.8853C20.5824 28.1558 20.5752 28.0596 20.5752 27.0674C20.5751 26.509 20.5876 25.9909 20.6056 25.8023C20.6223 25.6266 20.6477 25.3613 20.6619 25.2127C20.6924 24.8933 20.7688 24.2953 20.8188 23.9844C20.8521 23.7772 20.8878 23.5797 20.9722 23.1369C21.0221 22.8746 21.0406 22.7193 21.0218 22.7193C21.0129 22.7193 20.9829 22.7552 20.9553 22.7991Z",
    fill: "#848FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.2f42fd53cabd8d6fd6354069c9ea3df2.svg";
export { ForwardRef as ReactComponent };